import { createRoutine } from 'redux-saga-routines';

export const fetchIntegrations = createRoutine('FETCH_INTEGRATIONS');

export const fetchIntegretionMetaData = createRoutine(
  'FETCH_INTEGRATION_META_DATA'
);
